import type { Snack } from '@/features/snacks/types/Snack';
import type { RootState } from '@/store/types/RootState';
import { addSnack, removeAllSnacks, removeSnack } from '@/features/snacks/store/snacksSlice';
import { store } from '@/store/store';

class SnacksService {
  static add(snack: Snack) {
    store.dispatch(addSnack(snack));
  }

  static remove() {
    store.dispatch(removeSnack());
  }

  static removeAll() {
    store.dispatch(removeAllSnacks());
  }

  static selectAll() {
    return (state: RootState) => state.snacksSlice.snacks || [];
  }
}

export default SnacksService;
